import React from 'react'
import ReactDOM from 'react-dom/client'
// The shared palette every other stylesheet aliases. First, so it reads as the
// base layer — the var() references that consume it resolve at compute time, so
// nothing here actually depends on import order.
import './styles/tokens.css';
import './styles/global.css';
import 'antd/dist/reset.css';
import 'react-toastify/dist/ReactToastify.css';
// Must come after the vendor stylesheet: it re-points toastify's own CSS
// variables and card styling at the app shell's palette. See the header comment
// in toast.css for why the theming lives in CSS rather than in JS.
import './styles/toast.css';
import App from "./App.jsx";

ReactDOM.createRoot(document.getElementById('root')).render(<App/>);
